import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import classnames from 'classnames'

import {jsonResponseHandler} from "../../../utils/FetchHelper"
import { connect } from "react-redux";
import Thumbnail from "../../../lib/Thumbnail";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({}), dispatch => ({
    dispatch
}))
class BlogIconForm extends Component {

	constructor() {
		super()
		this.state = {
			uploading: false
		}
	}

	@autobind
	handleUpload() {
		const { onChange } = this.props
		const { iconFile } = this.refs
		let files = iconFile.files

		if (files.length === 0) {
			return
		}

		let file = iconFile.files[0]
		if (file.size > 100000) {
			alert("파일 사이즈가 너무 큽니다. 100KB 이하의 파일을 사용해주세요.")
			return
		}

		this.uploadIcon(files[0]).then(url => {
			if (!url) {
				return
			}
			onChange(url)
		})
	}

	@autobind
	uploadIcon(file) {
		const { dispatch } = this.props;
		const { iconFile } = this.refs
		let formdata = new FormData()
		formdata.append("files[]", file, file.name)

		this.setState({
			uploading: true
		})

		return fetch(addPrefix("/manage/setting/blog/icon.json"), {
			method: 'post',
			credentials: "include",
			body: formdata
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				iconFile.value = ''
				this.setState({
					uploading: false
				})
				return data.url
			})
			.catch(e => {
				console.error(e)
				alert("이미지를 업로드하지 못했습니다.")
				iconFile.value = ''
				this.setState({
					uploading: false
				})
			})
	}

	render() {
		const { uploading } = this.state
		const { icon, onDelete } = this.props

		const emptyIconImage = "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png"

		return (
			<fieldset className="fld_icon">
				<legend className="screen_out">아이콘 이미지 설정</legend>
				<div className="wrap_thumb icon_thumb">
					{ icon &&
						<img src={Thumbnail.make('C32x32', icon)} className="thumb_img" width="32" height="32" alt="" />
					}
					{ uploading &&
						<span className="ico_blog ico_loading"/>
					}
				</div>
				<strong className="tit_set">아이콘 <span className="info_sub">최적 사이즈 32x32, 64x64 / 파일형식 JPG, GIF, PNG</span></strong>
				<label className="lab_btn">
					<span className="txt_btn">불러오기</span>
					<input ref="iconFile" type="file" className="btn_g" accept="image/*" onChange={this.handleUpload} />
				</label>
				<label className={classnames("lab_btn", { "lab_off": !icon })}>
					<span className="txt_btn">삭제</span>
					<input type="button" className="btn_g" value="삭제" onClick={onDelete} disabled={!icon} />
				</label>
			</fieldset>
		)
	}
}

BlogIconForm.propTypes = {
	// fixme: 아이콘 삭제시 warning 발생하여 주석처리
	// icon: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	onDelete: PropTypes.func
}

export default BlogIconForm
